<template>
  <div class="ui dimmer modals page transition" v-bind:class="{ active: show }">
    <!--Mientras no se active se conseva la clase "hidden" y si se activa intercambiar por "active"-->
    <div class="ui mini modal transition" v-bind:class="{ active: show }">
      <!--Mismo caso-->
      <i class="close icon" @click="$emit('close')"></i>
      <div class="content">
        <div class="ui form" ref="form">
          <h3 class="ui dividing header fdinpro default-header-green">
            SOLICITUD DE BUNDLES
          </h3>
          <div class="ui message" style="display:block">
            <div class="has-text-centered">
              Si no tienes los assets del bundle descagarlos
              <a :href="assets_url">aquí</a>
            </div>
          </div>
          <div class="field">
            <label class="pt-05 fdinpro label-form">Subir testigo web</label>
            <input
              type="text"
              name="web_witness"
              placeholder=""
              v-model="d.web_witness"
            />
          </div>
          <div class="field">
            <label class="pt-05 fdinpro label-form"
              >Subir testigo redes sociales</label
            >
            <input
              type="text"
              name="social_witness"
              placeholder=""
              v-model="d.social_witness"
            />
          </div>
          <div
            class="ui fluid button modal-button-green"
            tabindex="0"
            @click="request"
          >
            Solicitar Aprobación
          </div>
          <div class="ui error message"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { local_api, error_toast } from "@/utils";

export default {
  name: "",
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    form() {
      let vm = this;
      return window.jQuery(vm.$refs.form).form({
        fields: {
          web_witness: ["empty"],
          social_witness: ["empty"],
        },
      });
    },
  },
  data() {
    return {
      d: {
        web_witness: "",
        social_witness: "",
      },
      assets_url: "http://ellink.com",
      stores: [],
    };
  },
  methods: {
    request() {
      let vm = this;
      let isFormValid = true;
      isFormValid = vm.form.form("validate form");
      if (isFormValid) {
        local_api(vm, "post", "/nvidia_ticket/store/do-request-bundle", {
          d: vm.d,
        })
          .then(function(r) {
            console.log(r);
          })
          .catch(function(err) {
            error_toast(err);
          });
      }
    },
    setStores(stores) {
      let vm = this;
      vm.stores = stores;
    },
  },
};
</script>

<style scoped>
.py-2 {
  padding-top: 2rem !important;
  padding-bottom: 2rem !important;
}
.fdinpro {
  font-family: "DINPro" !important;
}
.default-header-green {
  border-bottom: 2pt solid #365a0c !important;
  font-weight: 300;
  font-size: 1.5rem !important;
}
.is-uppercase {
  text-transform: uppercase !important;
}

/*  SIDE BAR BUTTONS    */
.pbundle {
  align-items: center !important;
}
.pbundle div button {
  border-radius: 2rem !important;
}
.pbundle div .cgray {
  font-weight: 700 !important;
}
.modal-button-green {
  background-color: #365a0c !important;
  color: white !important; /*width: 100%;*/
  font-family: "DINPro" !important;
  font-weight: 500;
}
.modal-button-green:hover {
  background-color: rgb(118, 185, 0) !important;
}
</style>
